const openCloseAddGroupSet = (state, action) => ({
  ...state,
  createGroupSetDialogOpen: action.payload.createGroupSetDialogOpen,
});

export default openCloseAddGroupSet;
